import { render, staticRenderFns } from "./notificationDetail.vue?vue&type=template&id=33279e86&scoped=true&"
import script from "./notificationDetail.vue?vue&type=script&lang=js&"
export * from "./notificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./notificationDetail.vue?vue&type=style&index=0&id=33279e86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33279e86",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
